// Currency and number formatting utilities

// Get currency from localStorage or default to RSD
export const getCurrency = () => {
  return localStorage.getItem('currency') || 'RSD';
};

// Set currency
export const setCurrency = (currency) => {
  localStorage.setItem('currency', currency);
  window.dispatchEvent(new CustomEvent('currencyChanged', { detail: { currency } }));
};

// Get currency format from localStorage or default
export const getCurrencyFormat = () => {
  return localStorage.getItem('currencyFormat') || 'european';
};

// Get number format based on currency format setting
export const getNumberFormat = (currency = null) => {
  const format = getCurrencyFormat();
  
  // European format: 123.456,00
  if (format === 'european') {
    return {
      decimal: ',',
      thousands: '.',
      precision: 2
    };
  }
  
  // US format: 123,456.00
  return {
    decimal: '.',
    thousands: ',',
    precision: 2
  };
};

// Format number with currency
export const formatCurrency = (amount, currency = null, showSymbol = true) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return showSymbol ? `${getCurrency()} 0,00` : '0,00';
  }
  
  const curr = currency || getCurrency();
  const format = getNumberFormat(curr);
  const num = parseFloat(amount);
  
  // Format number
  const parts = num.toFixed(format.precision).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, format.thousands);
  const decimalPart = parts[1] || '00';
  
  const formatted = `${integerPart}${format.decimal}${decimalPart}`;
  
  if (!showSymbol) {
    return formatted;
  }
  
  // Add currency symbol
  const symbols = {
    'RSD': 'RSD',
    'EUR': '€',
    'USD': '$',
    'GBP': '£'
  };
  
  const symbol = symbols[curr] || curr;
  
  // RSD and EUR use space before, others use symbol before
  if (curr === 'RSD' || curr === 'EUR') {
    return `${symbol} ${formatted}`;
  }
  
  return `${symbol}${formatted}`;
};

// Parse formatted currency string to number
export const parseCurrency = (value, currency = null) => {
  if (!value || typeof value !== 'string') {
    return 0;
  }
  
  const curr = currency || getCurrency();
  const format = getNumberFormat(curr);
  
  // Remove currency symbols and spaces
  let cleaned = value.replace(/[^\d.,\-]/g, '');
  
  // Replace decimal separator based on format
  if (format.decimal === ',') {
    // European format: replace last comma with dot, remove other commas
    const lastCommaIndex = cleaned.lastIndexOf(',');
    if (lastCommaIndex !== -1) {
      cleaned = cleaned.substring(0, lastCommaIndex).replace(/\./g, '') + '.' + cleaned.substring(lastCommaIndex + 1);
    } else {
      cleaned = cleaned.replace(/\./g, '');
    }
  } else {
    // US format: remove commas
    cleaned = cleaned.replace(/,/g, '');
  }
  
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
};

